import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
    TagsApplicantCount,
    assignApplicatintsCount,
    enterpriseTagsKey,
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetAssignedTagApplicatsProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
    selectedCompanyId?: number | string;
    id?: number | null;
};

export const useGetAssignedTagApplicats = ({
    setErrorText = () => { },
    id,
    selectedCompanyId
}: useGetAssignedTagApplicatsProps) => {
    const { data: assignedApplicantsCount, isFetching: isLoadingCount, } = useQuery<TagsApplicantCount>({
        queryKey: [enterpriseTagsKey, id],
        queryFn: () => {
            const params = new URLSearchParams();

            params.append('tag_id', String(id));
            params.append('company_id', String(selectedCompanyId));

            return axiosInstance
                .get(assignApplicatintsCount, { params })
                .then((res) => res.data);
        },
        onSuccess: (data) => {
            if (data.status == 200) {
                setErrorText('');
            }
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
        enabled: Boolean(id),
    });

    return {
        assignedApplicantsCount,
        isLoadingCount
    };
};
